import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { registerSW } from 'virtual:pwa-register';
import './styles/main.css';

// Auto-update service worker silently when a new version is available
registerSW({ immediate: true });

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');
